const controller = "leads";

export default {
  controller,
  filter: controller + "/filter",
};
